import { useMemo } from 'react'
import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { useAppSelector } from 'hooks/reduxHooks'
import type { StatusMatchCampaignConfig } from 'loyalty/statusMatch/statusMatchTypes'
import { resolveStatusMatchCampaignFromFlag } from 'loyalty/statusMatch/resolveStatusMatchLabConfig'

function useStatusMatchCampaign(slug: string): StatusMatchCampaignConfig | undefined {
  const flag = useLabFeatureFlag(LabFeatureFlags.enableStatusMatch)
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)

  return useMemo(
    () => resolveStatusMatchCampaignFromFlag(flag, regionCode, slug),
    [flag, slug, regionCode],
  )
}

export default useStatusMatchCampaign
